import type React from 'react';

import cn from '../../../utils/cn';

export interface StatsItemProps {
  children: React.ReactNode;
  className?: string;
}

const StatsItem = ({ children, className }: StatsItemProps) => {
  return <div className={cn('flex items-center space-x-2', className)}>{children}</div>;
};

StatsItem.displayName = 'Stats.Item';

export default StatsItem;
